var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: _vm.classes }, [
    _c("div", { staticClass: "removable-entry__text" }, [_vm._t("default")], 2),
    _vm._v(" "),
    _c(
      "button",
      {
        staticClass: "removable-entry__hide",
        attrs: {
          id: "remove-entry",
          "aria-label": _vm.$t("chatbot.removeFile"),
        },
        on: {
          click: function ($event) {
            return _vm.$emit("close")
          },
        },
      },
      [_c("close-icon", { attrs: { "aria-labelledby": "remove-entry" } })],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }